import { ApolloError } from '@apollo/client';
import { ParsedPromo } from '../../components/Layout/Promotions/types';

export type ParsedPlatformPromos = {
  magicXPromos: ParsedPromo[];
  depositPromos: ParsedPromo[];
  rewardsPromos: ParsedPromo[];
  userTags: UserTags;
};

export type PlatformPromos = {
  platformPromos: ParsedPlatformPromos;
  isPromosLoading: boolean;
  promosLoadingError: unknown | ApolloError;
};

export enum PromoTagCategory {
  BONUS = 'Bonus',
}

export type UserTags = (string | null | undefined)[] | undefined;
